var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRide24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#F2994A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 8c-5.5 0-10 4.3-10 9.7C42 25 52 34 52 34s10-9 10-16.3C62 12.3 57.5 8 52 8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 17.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 57,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 57,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 57h14c6 0 10-4 10-9s-4-9-10-9H24c-5 0-8-3-8-7s3-7 8-7h12",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 66h61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRide24);
export default __webpack_public_path__ + "static/media/Ride24.0c8d3df098bbad3a24999b8f216671f4.svg";
export { ForwardRef as ReactComponent };